// src/lib/scrollToTop.ts
export const scrollToTop = () =>
  window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
